import { useState } from "react";
import MyDivider from "src/components/layout/MyDivider";
import PropTypes from "prop-types";
import MySwitch from "src/components/MySwitch/MySwitch";
import { Typography } from "@mui/material";
import { requestPermission } from "src/firebase/firebase";
import firebaseClass from "src/data/system/firebaseClass";

import { isMobile } from "react-device-detect";
import { useUserData } from "src/context/userContext";

export default function ConfirmRightButtonModalSwitch1(props) {
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);
  const { user, token } = useUserData();

  const [permissionGranted, setPermissionGranted] = useState(undefined);
  const [key, setKey] = useState(0);

  const handleChange = (isChecked) => {
    setChecked1(isChecked);
    props.onChange(isChecked && checked2);
  };
  const handleChange2 = (isChecked) => {
    setChecked2(isChecked);
    props.onChange(isChecked && checked1);
  };
  const handleChange3 = async (isChecked) => {
    if (isChecked) {
      const thisFCMToken = await requestPermission();
      if (thisFCMToken == null) {
        setChecked3(false);
        props.onChange3(false);
        setPermissionGranted(false);
        setKey(key + 1);
      } else {
        setChecked3(true);
        props.onChange3(true);
        setPermissionGranted(true);
        const personId = Number(user.personId);
        const fb = new firebaseClass(personId);
        await fb.addPersonDevice(thisFCMToken, token, isMobile);
      }
    } else {
      setChecked3(false);
      props.onChange3(false);
    }
  };
  return (
    <>
      <Typography variant="h6" color="primary">
        Ilmoitukset
      </Typography>
      <MySwitch
        key={key}
        rightSide={
          "Haluan ilmoituksen " +
          (isMobile ? "puhelimeeni " : "") +
          "kun tilaukseen tehdään muutoksia."
        }
        checked={checked3}
        onChange={handleChange3}
        helpId="asiakasSwitch:haluan ilmoituksen kun joku muu tekee muutoksia tilaukseeni"
        isError={permissionGranted === false}
        errorMsg={
          <Typography variant="body2" color="warning.main">
            Ilmoitukset eivät toimi, koska et ole antanut lupaa.
          </Typography>
        }
      />
      <MyDivider gutter />
      <Typography variant="h6" color="primary">
        Ehdot
      </Typography>
      <MySwitch
        rightSide="Vahvistan että valittu betonilaatu on rakennepiirustusten mukainen tai rakennesuunnitelijan hyväksymä."
        checked={checked1}
        onChange={handleChange}
        helpId="asiakasSwitch:Vahvistan että betoni on rakennepiirustusten mukainen"
      />
      <MyDivider gutterHeight="6px" gutter />
      <MySwitch
        rightSide="Hyväksyn että yhteystietoni jaetaan kaikkien tilaukseen liittyvien osapuolten kesken."
        checked={checked2}
        onChange={handleChange2}
        helpId="asiakasSwitch:Hyväksyn että yhteystietoni jaetaan"
      />
    </>
  );
}

ConfirmRightButtonModalSwitch1.propTypes = {
  onChange: PropTypes.func,
  onChange3: PropTypes.func,
};
